import { render, staticRenderFns } from "./RegionView.vue?vue&type=template&id=6cbd441b&scoped=true"
import script from "./RegionView.vue?vue&type=script&lang=js"
export * from "./RegionView.vue?vue&type=script&lang=js"
import style0 from "./RegionView.vue?vue&type=style&index=0&id=6cbd441b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cbd441b",
  null
  
)

export default component.exports